// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".favorite-work-preview-trigger[data-v-135ac532]{clip:rect(0,0,0,0);border-width:0;height:1px;margin:-1px;overflow:hidden;padding:0!important;position:absolute;white-space:nowrap;width:1px}.favorite-work-preview-trigger[data-v-135ac532]:focus-visible{clip:auto;border-width:1px;height:2.5rem;margin:0;overflow:visible;padding:.5rem .75rem!important;position:static;white-space:normal;width:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
